import { Component, OnInit } from '@angular/core';
import { OffboardingService } from 'src/app/services/offboarding.service';
import { OffboardingClient } from 'src/app/shared/models/offboarding/offboarding-client';
import { OffboardingClientListResponse } from 'src/app/shared/models/offboarding/offboarding-client-list-response';
import { SettingsService } from 'src/app/services/settings.service';
import { UserService } from 'src/app/services/user.service';
import { UserFullDetails } from 'src/app/shared/models/users/user-full-details';
import { Note } from 'src/app/shared/models/note/note';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-offboarding',
  templateUrl: './offboarding.component.html',
  styleUrls: ['./offboarding.component.scss'],
})
export class OffboardingComponent implements OnInit {
  isCollapsed = false;
  showError: boolean = false;
  errorResponse: HttpErrorResponse;
  selectedUserFullDetails: UserFullDetails;

  loadingProfile = false;
  loadingClientList = false;
  infoLoading: boolean = false;
  showUserProfileModal = false;

  filterableClients: OffboardingClient[] = [];
  clientListResponse: OffboardingClientListResponse = new OffboardingClientListResponse();

  searchText: string = '';

  selectedClientId: number | null;

  createdByUserId: number | null;

  offboardingClient: OffboardingClient;

  constructor(
    private offboardingService: OffboardingService,
    private settingsService: SettingsService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.createdByUserId = this.settingsService.user.id;
    this.LoadOffboardingClients();
  }

  onClientSelect(clientId: number) {
    this.isCollapsed = true;
    this.selectedClientId = clientId;
    this.GetOffboardingClientInformation();
  }

  onGridCollapse() {
    this.isCollapsed = !this.isCollapsed;
    this.selectedClientId = null;
  }

  onEditProfileClick() {
    this.GetUserFullDetails(this.selectedClientId);
  }

  canArchive(): boolean {
    if (!this.offboardingClient?.offboardingCategoriesAndSteps?.length) {
      return false;
    }
    const allSteps = this.offboardingClient.offboardingCategoriesAndSteps.flatMap((c) => c.steps);
    return allSteps.length > 0 && allSteps.every((s) => s.isCompleted);
  }

  archiveClient() {
    this.loadingClientList = true;
    this.offboardingService.ArchiveClient(this.selectedClientId, this.createdByUserId).subscribe({
      next: () => {
        this.removeClientFromArray();
        this.isCollapsed = false;
        this.selectedClientId = null;
        this.loadingClientList = false;
      },
      error: (error) => {
        this.loadingClientList = false;
        this.parseAndDisplayError(error);
      },
    });
  }

  parseAndDisplayError(error: any) {
    this.errorResponse = error;
    this.showError = true;
  }

  newNote: Note;

  handleNoteCreated(note: Note) {
    this.newNote = note;
  }

  handleUserProfileUpdated(userFullDetails: UserFullDetails) {
    if (userFullDetails.user.active == false) {
      this.removeClientFromArray();
      this.isCollapsed = false;
      this.selectedClientId = null;
    }
  }

  private LoadOffboardingClients() {
    this.loadingClientList = true;
    this.clientListResponse = null;
    this.offboardingService.GetOffboardingClients().subscribe({
      next: (response: OffboardingClientListResponse) => {
        this.clientListResponse = response;
        this.filterableClients = this.clientListResponse.clients;
        this.loadingClientList = false;
      },
      error: (error) => {
        this.loadingClientList = false;
        this.parseAndDisplayError(error);
      },
    });
  }

  private GetUserFullDetails(userId: number) {
    this.loadingProfile = true;
    this.userService.GetUserDetails(userId, true).subscribe({
      next: (fullDetails: UserFullDetails) => {
        this.showUserProfileModal = true;
        this.selectedUserFullDetails = fullDetails;
        this.loadingProfile = false;
        this.showError = false;
      },
      error: (error) => {
        this.loadingProfile = false;
        this.parseAndDisplayError(error);
      },
    });
  }

  private GetOffboardingClientInformation() {
    this.infoLoading = true;
    this.offboardingService.GetOffboardingClientInformation(this.selectedClientId).subscribe({
      next: (response: OffboardingClient) => {
        this.offboardingClient = response;
        this.infoLoading = false;
      },
      error: (error) => {
        this.infoLoading = false;
        this.parseAndDisplayError(error);
      },
    });
  }

  private removeClientFromArray() {
    this.clientListResponse.clients.splice(
      this.clientListResponse.clients.findIndex((client) => client.userId === this.selectedClientId),
      1
    );
    this.filterableClients = this.clientListResponse.clients;
  }
}
